import PhoneUtil from './PhoneUtil';
import RecordUtils from './RecordUtils';

export const convertSenderVariables = (text, userInfo) => {
    const {
        first_name: myFirstName = '',
        last_name: myLastName = '',
        work_phone: myPhone = '',
        cell_phone: myCell = '',
        company: { company_name: myCompany = '' }
    } = userInfo;
    const myFullName = `${myFirstName} ${myLastName}`;
    const formattedPhone = myPhone ? PhoneUtil.formatPhoneNumber(myPhone) :
        myCell ? PhoneUtil.formatPhoneNumber(myCell) : '';
    return text.replace(/%%My Full Name%%/g, myFullName).replace(/%%My First Name%%/g, myFirstName)
        .replace(/%%My Phone%%/g, formattedPhone).replace(/%%My Company%%/g, myCompany)
}

export const convertRecipientAccountVariables = (text, accountInfo) => {
    const { name = '', phones, locations: location=[] } = accountInfo;
    const defaultCity = location.find(loc => loc.main === true) || location[0] || {};
    const { street = '', city = '', state = '', zip = '' } = defaultCity;
    const address = `${street} ${city}, ${state} ${zip}`;
    let phone = phones ? phones.find(p => p.main === true) || phones[0] : '';
    const phoneFormatted = PhoneUtil.formatPhoneNumber(phone.phone)
    return text.replace(/%%Full Name%%/g, name).replace(/%%Phone%%/g, phoneFormatted)
        .replace(/%%Address%%/g, address).replace(/%%City%%/g, city).replace(/%%State%%/g, state).replace(/%%Zip%%/g, zip)
}

export const convertRecipientContactVariables = (text, contact) => {
    const contactInfo = {
        ...contact,
        ...contact.contact,
    };
    const fullName = `${RecordUtils.getName(contactInfo).firstLine || ''} ${RecordUtils.getName(contactInfo).secondLine || ''}`;
    const firstName = RecordUtils.getName(contactInfo).firstLine || '';
    const lastName = RecordUtils.getName(contactInfo).secondLine || '';
    const location = contactInfo.locations || [];
    const defaultCity = location.find(loc => loc.id === contactInfo.primary_location_id) || location[0] || {};
    const { street = '', additional_street = '', city = '', state = '', zip = '' } = defaultCity;
    return text.replace(/%%Full Name%%/g, fullName)
        .replace(/%%First Name%%/g, firstName).replace(/%%Last Name%%/g, lastName).replace(/%%Phone%%/g, PhoneUtil.formatPhoneNumber((contact.phone.find(p => p.main === true) || contact.phone[0] || { phone: '' })?.phone))
        .replace(/%%Address%%/g, `${street} ${additional_street} ${city}, ${state} ${zip}` || '').replace(/%%City%%/g, city).replace(/%%State%%/g, state)
        .replace(/%%Zip%%/g, zip)
}
